import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";
import "./../library/creativestyle.css";
import AdGroupHeroCard from "../components/AdGroupHeroCard";
import AdGroupMediaCard from "../components/AdGroupMediaCard";
import PageHeaderLayoutComponent from "../components/HeaderGroup";

const VideoGroupDetail = () => {
  const {
    adgroupinfo,
    refetchAdGroupInfo,
    orgVideoMedias,
    fetchVideoMedias,
  } = useLibraryCreativesContext();
  const [mediaKeys, setMediaKeys] = useState([]);

  // Ensure video media is loaded (lazy query may not have been triggered yet)
  useEffect(() => {
    if (!orgVideoMedias && fetchVideoMedias) {
      fetchVideoMedias();
    }
  }, [orgVideoMedias, fetchVideoMedias]);

  useEffect(() => {
    if (
      adgroupinfo &&
      adgroupinfo.adGroupCreatives &&
      adgroupinfo.adGroupCreatives.medias
    ) {
      const keys = adgroupinfo.adGroupCreatives.medias.map(media => media.key);
      setMediaKeys(keys);
    }
  }, [adgroupinfo]);

  return (
    <>
      <PageHeaderLayoutComponent adgroupinfo={adgroupinfo} mediaType="VIDEO" />
      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col span={24}>
          <AdGroupHeroCard
            adgroupinfo={adgroupinfo}
            mediaType="VIDEO"
            mediaKeys={mediaKeys}
          />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <AdGroupMediaCard
            mediaType="VIDEO"
            adgroupinfo={adgroupinfo}
            refetchAdGroupInfo={refetchAdGroupInfo}
            orgMedias={orgVideoMedias ? orgVideoMedias.medias : []}
            adGroupId={
              adgroupinfo && adgroupinfo.adGroupCreatives
                ? adgroupinfo.adGroupCreatives.id
                : ""
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default VideoGroupDetail;